import React, { useContext, useState, useCallback } from 'react';
import CollectAddressGooglePlacesAPIEmbeddable, {
  initialState as initialAddressState,
} from '../../library/CollectAddressGooglePlacesAPIEmbeddable';
import { StateContext } from '../../../state';
import Title from '../../library/Title';
import ConfigComponent from '../../ConfigComponent';
import { actions } from '../../../state/actions';
import StartOver from '../../library/StartOver';
import { get } from 'lodash/object';
import MuiButton from '../../library/MuiButton';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import settings from '../../../conf/settings';

// Styles
const useStyles = makeStyles((theme) => ({
  input: {
    width: 300,
    '& + &': {
      marginTop: 20,
    },
  },
  disabled: {
    pointerEvents: 'none',
    background: '#ECECEC',
  },
  submit: {
    width: 150,
    height: 45,
    marginTop: 10,
  },
}));

export function CollectAddressViewEmbeddable({ onSubmit, isFetching }) {
  const [
    {
      configuration: {
        recipientLogin: { title, description, startOverLink },
      },
    },
    dispatch,
  ] = useContext(StateContext);

  const classes = useStyles();

  const [{ accountConfiguration }] = useContext(StateContext);
  const googleApiKey = get(
    accountConfiguration,
    'helpers.googleAutocomplete.apiKey',
    settings.environment.DEV_ENVIRONMENT === 'DEV' // using dev api key to test on storybook as we aren't fetching the accounts
      ? 'AIzaSyCXv945-pbQhiiAUbCZmEiqEhso9ho7G_o'
      : ''
  );

  const autocompleteThrottleDurationInMs = get(
    accountConfiguration,
    'helpers.googleAutocomplete.throttleDurationInMs',
    300
  );

  const restrictToGoogleResults = get(
    accountConfiguration,
    'helpers.googleAutocomplete.restrictToGoogleResults',
    true
  );

  const allowManualOverride = get(
    accountConfiguration,
    'helpers.googleAutocomplete.allowManualOverride',
    false
  );

  const enableBrowserCache = get(
    accountConfiguration,
    'helpers.googleAutocomplete.enableBrowserCache',
    true
  );

  const [address, setAddress] = useState(initialAddressState);

  // validation state
  const [isAddressValid, setIsAddressValid] = useState(false);

  // handle address changes from child component
  const handleAddressChange = useCallback((newAddressValues) => {
    setAddress({
      ...address,
      ...newAddressValues,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // handle address validation changes from child component
  const handleAddressValidation = useCallback((isValid) => {
    setIsAddressValid(isValid);
  }, []);

  return (
    <>
      <Title>
        <h1>
          <ConfigComponent config={title} />
        </h1>
      </Title>
      <section>
        <p style={{ textAlign: 'center', padding: '1em 0 0 0' }}>
          <ConfigComponent
            config={description}
            actions={{ startOver: () => dispatch(actions.startOver()) }}
          />
        </p>
      </section>
      <section className="main">
        <CollectAddressGooglePlacesAPIEmbeddable
          onChange={handleAddressChange}
          onValidationChange={handleAddressValidation}
          googleApiKey={googleApiKey}
          restrictToGoogleResults={restrictToGoogleResults}
          allowManualOverride={allowManualOverride}
          autocompleteThrottleDurationInMs={autocompleteThrottleDurationInMs}
          enableBrowserCache={enableBrowserCache}
        />
      </section>
      <section style={{ padding: '1.5em 0' }}>
        <MuiButton
          className={clsx(classes.input, classes.submit, {
            [classes.disabled]: !isAddressValid,
          })}
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          isFetching={isFetching}
          disabled={!isAddressValid}
          onClick={() => onSubmit(address)}
        >
          Submit
        </MuiButton>
      </section>
      {get(startOverLink, 'show') && (
        <section>
          <StartOver {...get(startOverLink, 'props', {})} />
        </section>
      )}
    </>
  );
}

export default CollectAddressViewEmbeddable;
